import React from 'react'
import Logo from "../assets/logo.png";
const ImagePage = ({qrData}) => {
  return (
    <div className="sign_up_page">
      <div className="three-corner-curve"></div>

      <div className="sign_up_logo">
        <img src={Logo} alt="logo" />
      </div>
      <div className="sign_up_form_body">
        <div className="sign_up_form_heading">Image By</div>
      <div className="sub_heading">
        {qrData?.first_name || ""} {qrData?.last_name || ""}
      </div>
      <div className="qr_container">
        <img
          src={qrData?.image || ""}
          alt="QR Code"
          className="qr_image"
        />
      </div>
    </div>
  </div>
  )
}

export default ImagePage